// Copyright (c) 2020 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {hasAccess} from '../../../shared/services/security';

export const isUserSelectedStatus = statusKey => ['01', '1', '4', '7', '8', '9'].some(selectedStatusKey => selectedStatusKey === statusKey);

export const isMatchingStatus = (statusKey, selectedStatusList) => selectedStatusList.find(selectedStatus => selectedStatus.key === statusKey);

export const mapSearchPlaceHolderSapDown = key => {

    const map = {
        PRODUCTS: 'SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER'
    };

    const mapKey = map[key] || '';

    return mapKey;

};

export const mapValidationErrorMessages = key => {

    const map = {
        PRODUCTS: 'SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL'
    };

    return map[key];

};

export const mapSearchRoutes = (key, query) => {

    const map = {
        PRODUCTS: `products/${encodeURIComponent(query)}`
    };

    return map[key];

};

/* eslint-disable complexity */

export const getSearchBySapDown = security => {

    const searchBy = [];

    if (hasAccess(security, 'PRT', 'PRT_PRODUCT_SEARCH')) {

        searchBy.push(new KeyValuePair({
            key: 'PRODUCTS',
            value: 'PRODUCTS'
        }));

    }

    return searchBy;

};

/* eslint-enable complexity */

export const getSearchBySelectedOption = searchBy =>
    searchBy.length > 0 ? searchBy[0].key : '';



// WEBPACK FOOTER //
// ./src/home-page/shared/services/home-page-helper-sap-down.js